import { render, staticRenderFns } from "./SettingsCreate.vue?vue&type=template&id=a4fab666&scoped=true&"
import script from "./SettingsCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fab666",
  null
  
)

export default component.exports